// extracted by mini-css-extract-plugin
export default {"reuploadFailed":"ReuploadFailed_reuploadFailed__2Efsu","message":"ReuploadFailed_message__SfFze"};